import type { ReactNode } from 'react';

interface Props {
  kicker?: string;
  title: string;
  meta?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export function ListPageShell({ kicker, title, meta, actions, children }: Props) {
  return (
    <div className="space-y-4 sm:space-y-6 animate-fade-in">
      <div className="rounded-xl border border-slate-200 bg-white p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
          <div className="min-w-0">
            {kicker && (
              <div className="font-mono-num text-[10px] uppercase tracking-[0.18em] text-slate-400 mb-1">
                {kicker}
              </div>
            )}
            <h1 className="text-[22px] sm:text-[24px] font-semibold tracking-tight text-slate-900">
              {title}
            </h1>
            {meta && (
              <div className="text-[13px] text-slate-500 mt-0.5">{meta}</div>
            )}
          </div>
          {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
      </div>
      {children}
    </div>
  );
}
